<template>
  <v-dialog v-model="fullAdImageTwo" fullscreen>
    <v-card>
      <v-img :src="`/frontpageProfile.png`" width="100%" height="100%" contain @click="closeDialog"></v-img>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data(){
    return{
      item: {},
      fullAdImageTwo: false,
    }
  },
  methods: {
    openDialog(articledata) {
      this.fullAdImageTwo = true;
    },
    closeDialog(){
      this.fullAdImageTwo = false;
    }
  }
}
</script>